module.exports = __webpack_public_path__ + "static/media/link-darkmode.86fd8583.svg";